var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPushpin = function SvgPushpin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9 8.646l-7.516-7.558c-1.414-1.421-3.878-1.436-5.32-0.011-0.369 0.369-0.658 0.82-0.786 1.183-1.228 2.561-2.546 4.164-4.238 5.127l-0.408 0.197c-1.82 0.912-4.296 1.841-8.872 1.841-0.5 0-0.979 0.098-1.44 0.286-0.91 0.38-1.653 1.119-2.034 2.038-0.374 0.91-0.374 1.957 0 2.867 0.196 0.468 0.47 0.886 0.818 1.224l6.082 6.082-7.185 10.064 10.062-7.185 6.067 6.067c0.35 0.355 0.763 0.637 1.233 0.829 0.464 0.194 0.946 0.29 1.44 0.29s0.976-0.098 1.438-0.29c0.936-0.385 1.66-1.113 2.030-2.027 0.194-0.455 0.291-0.953 0.291-1.444 0-4.58 0.929-7.054 1.839-8.876 0.933-1.865 2.574-3.286 5.178-4.538 0.509-0.196 0.959-0.481 1.337-0.859 1.451-1.47 1.444-3.856-0.015-5.305zM21.034 17.672c-1.54 3.089-2.233 6.336-2.247 10.536l-15.027-15.023c4.021 0 7.17-0.63 10.145-2.038l0.442-0.197c2.63-1.314 4.64-3.559 6.37-7.208l7.377 7.616c-3.503 1.679-5.745 3.685-7.059 6.315z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPushpin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pushpin.2bcb48ba.svg";
export { ForwardRef as ReactComponent };